import {
  getTranslations,
  refreshTranslations,
} from '@manager/api/services/translation-service';
import { useCustomMutation } from '@manager/api/use-custom-mutation';
import { useTranslate } from '@manager/composables/use-translate';
import { useQuery } from '@tanstack/vue-query';
import { computed, type MaybeRefOrGetter, toRef } from 'vue';

export function useTranslationsQuery(
  enabled: MaybeRefOrGetter<boolean> = true
) {
  const { locale } = useTranslate();
  const enabledRef = toRef(enabled);
  return useQuery({
    queryKey: ['translations', locale],
    queryFn: () => getTranslations(),
    enabled: computed(() => enabledRef.value),
  });
}

export function useTranslationsRefreshMutation() {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return useCustomMutation<Record<string, any>, void>({
    mutationFn: () => refreshTranslations(),
  });
}
